@if (isInputLike) {
  <div>
    <blaze-tags-column-value
      [value]="value"
      [fitToContainer]="true"
      [useExternalClickAction]="true"
      [isMultipleValue]="isMultiple"
      (clickAction)="externalClickAction($event)"
      [palette]="palette"
    />
  </div>
}
<div #menuTrigger [matMenuTriggerFor]="menu"></div>
<mat-menu #menu class="bd-menu inline-editor-tag-menu">
  @if (isAllowedToCreateNewValues) {
    <div class="searchbox">
      <input
        #filterInput
        [formControl]="searchFormCtrl"
        autocomplete="off"
        name="search-input"
        placeholder="Add new"
        class="p-12 rounded search-input"
        type="text"
        (click)="preventEventAction($event)"
        (blur)="focusFilter()"
        (keypress)="createTag($event)"
      />
      @if (searchFormCtrl.value) {
        <span class="add-new-instructions">Hit enter</span>
      }
    </div>
  }
  @for (tag of possibleNewValues; track tag) {
    <button class="min-w-[112px]" mat-menu-item (click)="addTag($event, tag)">
      <span class="tag" [ngStyle]="tag.value | stylesForTag: palette">
        {{ tag.value }}
      </span>
    </button>
  }
  @if (!possibleNewValues?.length) {
    <button class="empty-list-notification"> No values to select </button>
  }
</mat-menu>
